import React , { useState } from 'react';
import Dialog, { DialogProps } from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import Slide from '@material-ui/core/Slide';
import { TransitionProps } from '@material-ui/core/transitions';
import { ListingItemCard} from '../../components';
import { makeStyles } from '@material-ui/core/styles';

import DoneIcon from '@material-ui/icons/Done';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import { UpsellTitles, ServiceTitles } from 'models/backend/constant/Upsell';
// import { RoomUpgrade } from "models/RoomUpgrade";
// import { Food } from 'models/Food';
// import { Beverage } from 'models/Beverage';
// import { Facilities } from 'models/Facilities';
import { mockAmenities, mockFacilities, mockRoomService, mockRooms } from 'mock/mockUpsellData';

// type mockDataType = RoomUpgrade | Food | Beverage | Facilities ;

const useStyles = makeStyles((theme) => ({
  appBar: {
    position: 'fixed',
    backgroundColor: theme.palette.primary.main
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1
  }
}));

const Transition = React.forwardRef(function Transition(
    props: TransitionProps & { children?: React.ReactElement },
    ref: React.Ref<unknown>) 
{
    return <Slide direction="up" ref={ref} {...props} />;
});

interface IProps extends DialogProps {
  onCompleted: (isCompleted: boolean, snackBarMessage: string) => void;
  title: string;
};

export const ListingItemDialog: React.FC<IProps> = ({ onCompleted, title, open, children, ...rest }) => {
    const classes = useStyles();
    const [message, setMessage] = useState("");
    const [isCompleted, setIsCompleted] = useState(false);
    const [data, setData] = useState<any[]>([]);
    const handleClose = () => {
        onCompleted(true, message);
    };

    const handleBack = () => {
        onCompleted(false, "");    
    };

    const handleSetMessage = (message: string) => {
        setMessage(message);
    };

    const handleCompleted = (isCompleted: boolean) => {
        setIsCompleted(isCompleted);
    };
   
    React.useEffect(()=>{
        switch(title){
            case UpsellTitles.RoomUpgrade:
                setData(mockRooms);
                break;
            case UpsellTitles.RoomService:
                setData(mockRoomService);
                break;
            case UpsellTitles.FacilitiesBooking:
                setData(mockFacilities);
                break;
            case ServiceTitles.Amenities:
                setData(mockAmenities);
                break;
        };
    },[title]);

    return (
        <Dialog fullScreen open={open} onClose={handleClose} TransitionComponent={Transition} {...rest}>
            <AppBar className={classes.appBar}>
            <Toolbar>
                {
                <IconButton edge="start" color="inherit" onClick={handleBack} aria-label="close">
                    <ArrowBackIosIcon />
                </IconButton>
                }
                <Typography variant="h6" className={classes.title}>
                {title}
                </Typography>
                {
                <IconButton disabled={!isCompleted} edge="start" color="inherit" onClick={handleClose} aria-label="close">
                    <DoneIcon />
                </IconButton>
                }
            </Toolbar>
            </AppBar>

            <Toolbar />

            <ListingItemCard onSetMessage={handleSetMessage} data={data} onCompleted={handleCompleted}/>
            
        </Dialog>
    );
};
